import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectTestsTab } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { MarkingSheetStatus } from "../../../types";
import { useStyles } from "./styles";

const TestsTab = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(selectTestsTab);

  if (!data) {
    return null;
  }

  return (
    <Box className={styles.content}>
      <Box className={styles.section}>
        <Typography className={styles.sectionTitle}>
          {t("VECHILE_STATUS.TESTS.SIGNATURES")}
        </Typography>
        <Box className={styles.signaturesRow}>
          {data.signatures.map((signature) => (
            <Box key={signature.id} className={styles.field}>
              <Typography className={styles.label}>
                {t(signature.labelKey)}
              </Typography>
              <Box
                className={
                  signature.status === "signed"
                    ? styles.statusSigned
                    : styles.statusUnsigned
                }
              >
                {signature.status === "signed" && (
                  <CheckIcon className={styles.checkIcon} />
                )}
                {t(
                  signature.status === "signed"
                    ? "VECHILE_STATUS.TESTS.SIGNED"
                    : "VECHILE_STATUS.TESTS.NOT_SIGNED"
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      <Box className={styles.fieldsRow}>
        <Box className={styles.field}>
          <Typography className={styles.label}>
            {t("VECHILE_STATUS.TESTS.MARKING_SHEET")}
          </Typography>
          <Select
            className={styles.select}
            value={data.markingSheet.value}
            onChange={(event) =>
              dispatch(actions.updateTestsMarkingSheet(event.target.value))
            }
            IconComponent={KeyboardArrowDownIcon}
            MenuProps={{
              PaperProps: { className: styles.selectMenuPaper },
            }}
            fullWidth
          >
            {Object.values(MarkingSheetStatus).map((value) => (
              <MenuItem key={value} value={value}>
                {t(`VECHILE_STATUS.TESTS.MARKING_SHEET_STATUS.${value}`)}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box className={styles.field}>
          <Typography className={styles.label}>
            {t("VECHILE_STATUS.TESTS.INSPECTION_DATE")}
          </Typography>
          <TextField
            className={styles.input}
            value={data.inspectionDate}
            onChange={(event) =>
              dispatch(actions.updateTestsInspectionDate(event.target.value))
            }
            fullWidth
            variant="outlined"
          />
        </Box>
      </Box>

      <Button variant="contained" className={styles.saveButton}>
        {t("VECHILE_STATUS.TESTS.SAVE")}
      </Button>
    </Box>
  );
};

export default TestsTab;
